/* ==========================================================================
   Makefield — putter product page
   --------------------------------------------------------------------------
   The design puts the quantity stepper and Add to cart on one row. Dawn
   renders the quantity as its own block outside the <form>, with the Globo
   options in between, so CSS alone could only pair them with an offset the
   size of that option list — a value that changes with every configuration.

   This moves the stepper next to the buttons once, wraps the pair in a row,
   and lets section-mk-pdp.css lay them out. Without JS the page keeps Dawn's
   ordinary stacked layout, which still works.

   Scoped to the default product template; the gift-card page is excluded.
   ========================================================================== */

(function () {
  'use strict';

  function pair(root) {
    var quantity = root.querySelector('.product-form__quantity');
    var buttons = root.querySelector('.product-form__buttons');
    if (!quantity || !buttons) return;

    var row = buttons.parentElement;
    var paired = row && row.classList.contains('mk-pdp-row');

    if (!paired) {
      row = document.createElement('div');
      row.className = 'mk-pdp-row';

      /* Insert where the buttons are, then move both in — order matters so the
         stepper lands on the left, as the design shows. */
      buttons.parentNode.insertBefore(row, buttons);
    }

    /* The upsell app injects its own container into whatever wraps the buy
       buttons, which lands it inside this row and pushes Add to cart onto its
       own line. The row must hold exactly the stepper and the buttons, so
       anything else is moved out just above it — the app's markup still
       renders, simply not between the pair. */
    Array.prototype.slice.call(row.children).forEach(function (child) {
      if (child !== quantity && child !== buttons) {
        row.parentNode.insertBefore(child, row);
      }
    });

    /* appendChild moves an existing node, so this both builds the row the
       first time and restores the order if something re-parented them. */
    row.appendChild(quantity);
    row.appendChild(buttons);
  }

  /* Set while our own appendChild calls run, so the MutationObserver below can
     ignore the mutations this script causes. Without it each pass re-triggers
     the observer, which schedules the next pass -- a loop that never settles. */
  var applying = false;

  function initAll() {
    if (applying) return;
    applying = true;
    try {
      document
        .querySelectorAll('[data-template="product"]:not([data-template-suffix="gift-card"]) .product__info-container')
        .forEach(pair);
    } finally {
      /* Release after the observer has delivered this pass's records, which
         are queued as microtasks. */
      window.setTimeout(function () {
        applying = false;
      }, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /* The buy-buttons block re-renders on a variant change, which can put a
     fresh .product-form__buttons back outside the row. */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:change', initAll);

  /* Globo injects its options asynchronously and can re-render the form
     around them; re-pairing on those mutations keeps the row intact. */
  var form = document.querySelector('[data-template="product"]:not([data-template-suffix="gift-card"]) .product-form');
  if (form && window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      /* Coalesce bursts of mutations into one pass, and never react to our
         own DOM move. */
      if (applying || pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        initAll();
      }, 120);
    }).observe(form, { childList: true, subtree: true });
  }
})();
